<template>
	<div class="selected-product-info online-repurchase-summary">
		<div class="selected-product-info">
			<div class="wrapper">
				<div class="wrapper__desc">
					<div class="description bold" id="deviceSummary">
						{{ $t('console.informative_pricing') }}:
					</div>

					<div class="selected-product-bonus-price">
						<template v-if="selectedQuality">
							<div class="sumPrices">
								<div class="name bold">
									{{ selectedColor.name }}
								</div>
								<div class="price">
									{{ $n(selectedQuality.price, "currency") }}
								</div>
							</div>
						</template>
						<template v-if="selectedBonus">
							<div class="sumPrices">
								<div>
									{{ $t('buyout.deviceSummary.bonus') }}
								</div>
								<div class="price">
									+&nbsp;{{ $n(selectedBonus.bonus_value, "currency") }}
								</div>
							</div>
						</template>
						<template v-if="getTotalPriceCorrection !== 0">
							<div class="sumPrices">
								<div>
									{{ $t(getTotalPriceCorrection < 0? 'buyout.deduction' : 'buyout.surcharge') }}*
								</div>
								<v-tooltip bottom>
									<template v-slot:activator="{ on }">
										<v-icon color="default" v-on="on">
											mdi-information-variant
										</v-icon>
									</template>
									<span>{{ $t('buyout.info_price_deduction') }}</span>
								</v-tooltip>
								<div class="price">
									<template v-if="getTotalPriceCorrection < 0" >-&nbsp;</template>
            			<template v-if="getTotalPriceCorrection > 0" >+&nbsp;</template>
            			{{ $n(Math.abs(getTotalPriceCorrection), "currency") }}
								</div>
							</div>
						</template>
						<template v-if="selectedQuality">
							<div class="divider"></div>
							<div class="sumPrices">
								{{ $t('console.overall_informative_buyout_price') }}
									<v-tooltip bottom v-if="this.displayMinimalPriceHint">
										<template v-slot:activator="{ on }">
											<v-icon color="default" v-on="on">
												mdi-information-variant
											</v-icon>
										</template>
										<span>{{ $t('buyout.info_minimal_buyout_price') }}</span>
									</v-tooltip>
								<div class="price">
									{{ $n(this.finalBuyoutPrice, "currency") }}
								</div>
							</div>
						</template>
					</div>
				</div>
				<div class="selected-product-photo">
					<img :src="buildImageUrl(selectedColor.image)" alt="..." />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { VUEX_BUYOUT} from '../../../store/buyout';
import { mapState, mapGetters } from 'vuex';
import { buildImageUrl } from '../../../../js/buyout';
import { config } from '../../../config/buyout';
import SanitizeMixin from '../../../mixins/buyout/sanitize';
import {GETTER_TYPES} from "../../../store/buyout/_getter-types";

export default {
	name: 'DeviceSummary',
	mixins: [SanitizeMixin],
	computed: {
		...mapState(VUEX_BUYOUT.NAMESPACE, [
			'selectedColor',
			'selectedBonus',
			'selectedQuality',
		]),
		 ...mapGetters(VUEX_BUYOUT.NAMESPACE, [
      GETTER_TYPES.GET_TOTAL_PRICE_CORRECTION,
    ]),
		currency() {
			return this.$sanitize(config.currency);
		},
		buyoutPrice(){
      let buyout_price = this.selectedQuality.price + this.getTotalPriceCorrection;
       if(this.selectedBonus)
        buyout_price += this.selectedBonus.bonus_value;
      return buyout_price;
    },
    displayMinimalPriceHint(){
      return this.buyoutPrice < this.minimal_buyout_price;
    },
    finalBuyoutPrice(){
      return Math.max(this.buyoutPrice, this.minimal_buyout_price);
    }
	},
	data() {
		return {
      minimal_buyout_price: config.minimal_buyout_price,
		};
	},
	methods: {
		buildImageUrl(url) {
			return buildImageUrl(url);
		}
	}
}
</script>
